export let followUp_Button = "DmhcMc";
export let send_receive_tab = "mHUWdc";
export let folder_tab = "MnbBN";
export let newFolder_Button = "PhfLSc";
export let newSearchFolder_Button = "DDXF0c";
export let folderPermissions_Button = "hUA5Fc";
export let sendReceiveAllFolders_Button = "yxAKfe";
export let workOffline_Button = "zjYaTb";
export let teams_ChatAroundEmailButton = "aqvkt";
export let teams_ChatAroundEmailAllButton = "pbjhO";
export let Teams_ChatAroundEmailFlyoutButton = "deBoRb";
export let instantMessage_Button = "Ngfxjc";
export let teams_ShareToTeamsChatButton = "TJ1aSd";
export let copyToButton = "oEzwRb";
export let myDayButton = "O3kuid";
export let toDoBarButton = "$ps5V";
export let currentViewButton = "ILJKpb";
export let conversationSettingsButton = "_wy9rb";
export let messagePreviewWin32Button = "I$Hgfe";
export let useTighterSpacingButton = "fcgxye";
export let myDayMenuShow = "yURwte";
export let myDayMenuHide = "BbFiue";
export let unifiedInboxSettingsButton = "HmSCDe";
export let folderSettingsButton = "D5ezCb";
export let favoriteSettingsButton = "Hy39K";
export let customSortButton = "n_4eBe";
export let lightRPOnButton = "BVoWLb";
export let lightRPOffButton = "ltagUd";
export let messageListOrganizationButton = "c8LOsc";
export let classicIndentedViewButton = "wnFajb";
export let readingPaneMessageViewButton = "AyFE9c";
export let createQuickStep_Button = "UjaL4";
export let allApps_Button = "CdCLSe";
export let move_Button_Win32 = "K0T9v";
export let newEmail_Button = "hLr9yb";
export let newItems_Button = "ptGv8d";
export let unreadRead_Button = "E1m5ne";
export let browseGroups_Button_Win32 = "pGOiOb";
export let newGroup_Button_Win32 = "MCqIMd";
export let newGroupDisabled_Tooltip = "BMadld";
export let focusedInbox_Button = "oEP2ib";
export default {followUp_Button,send_receive_tab,folder_tab,newFolder_Button,newSearchFolder_Button,folderPermissions_Button,sendReceiveAllFolders_Button,workOffline_Button,teams_ChatAroundEmailButton,teams_ChatAroundEmailAllButton,Teams_ChatAroundEmailFlyoutButton,instantMessage_Button,teams_ShareToTeamsChatButton,copyToButton,myDayButton,toDoBarButton,currentViewButton,conversationSettingsButton,messagePreviewWin32Button,useTighterSpacingButton,myDayMenuShow,myDayMenuHide,unifiedInboxSettingsButton,folderSettingsButton,favoriteSettingsButton,customSortButton,lightRPOnButton,lightRPOffButton,messageListOrganizationButton,classicIndentedViewButton,readingPaneMessageViewButton,createQuickStep_Button,allApps_Button,move_Button_Win32,newEmail_Button,newItems_Button,unreadRead_Button,browseGroups_Button_Win32,newGroup_Button_Win32,newGroupDisabled_Tooltip,focusedInbox_Button};